export default __webpack_public_path__ + "static/media/CCSType1.13431c21.png";